import Glide from '@glidejs/glide';
import {format_date, handleize, objectsAreEqual} from "../helpers";
import axios from 'axios';

export default {
  template: "#vue-product",
  delimiters: ["${", "}"],
  props: {
    pid: String,
    sh_id: String,
    pre_order_date: String,
    custom_prop_validator: {type: Function, default: null},
  },
  data: function () {
    return {
      add_to_cart_error: false,
      product: {
        savings: null,
        price: null,
        compare_at_price: null,
      },
      description_expand: false,
      active_tab: "features",
      bullets: [],
      glide: null,
      upc: null,
      variant_id: null,
      variants: [],
      selected_attributes: [],
      last_selections: [],
      drafting_review: false,
      reported_reviews: {},
      review: {
        product_id: parseInt(this.pid),
        shopify_id: parseInt(this.sh_id),
        customer_id: customer_id || null,
        customer_name: "",
        customer_email: "",
        rating: 5,
        review_title: "",
        review_body: "",
        errors: [],
        status: null
      },
      custom_validation_errors: {}
    }
  },
  created() {
    this.$store.commit('registerComponent', {name: 'product', component: this})
  },
  computed: {
    selected_item() {
      const ret = this.variants.filter(e => {
        return parseInt(e.sku) === this.upc
      })
      return ret.length >= 1 ? ret[0] : null
    },
    option_availability() {
      if (this.variants.length === 0) {
        return {totals: null, selected: null}
      }
      const avail = this.$store.state.product_availability || {variants: {}}
      const n_options = this.variants[0].options.length
      // instantiate a dict of option_index -> attribute:stock
      // e.g. {0: {left: 12, right: 12}, 1: {p88: 9, p28: 4}}
      let totals = {}
      let selected = {}

      const last_indices = this.last_selections ? this.last_selections.map(e => parseInt(e.split("-")[0])) : []
      const last_vals = this.last_selections ? this.last_selections.map(e => e.substring(e.indexOf("-") + 1)) : []

      for (let i = 0; i < n_options; i++) {
        totals[i] = {}
        if (!last_indices.includes(i)) {
          selected[i] = {}
        }
      }

      for (let variant of this.variants) {
        let stock = (parseInt(variant.sku) in avail.variants ? 1 : 0)

        for (let i = 0; i < n_options; i++) {
          let attr = variant.options[i]
          if (attr in totals[i]) {
            totals[i][attr] += stock
          } else {
            totals[i][attr] = stock
          }
        }

        if (last_indices.length > 0) {
          let matches = variant.options[last_indices[0]] === last_vals[0]

          if (matches && last_indices.length === 2) { // must also match the previous selection
            matches = variant.options[last_indices[1]] === last_vals[1]
          }
          if (matches) {
            for (let i = 0; i < n_options; i++) {
              if (!last_indices.includes(i)) {
                let attr = variant.options[i]
                if (attr in selected[i]) {
                  selected[i][attr] += stock
                } else {
                  selected[i][attr] = stock
                }
              }
            }
          }
        }
      }
      return {totals: totals, selected: selected}
    },
    availability_classes() {
      if (!this.$store.state.product_availability) {
        return {}
      }
      const n_options = this.variants[0].options.length
      let output = {}
      for (let i = 0; i < n_options; i++) {
        for (let k of Object.keys(this.option_availability.totals[i])) {
          if (this.option_availability.totals[i][k] === 0) {
            output[`${i}-${k}`] = 'variant_blacked_out'
          } else if (i in this.option_availability.selected) {
            if (this.last_selections.length > 0 && !(k in this.option_availability.selected[i])) { // invalid selection
              output[`${i}-${k}`] = 'variant_greyed_out'
            } else if (k in this.option_availability.selected[i] && this.option_availability.selected[i][k] === 0) { // oos
              output[`${i}-${k}`] = 'variant_greyed_out'
            }
          }
        }
      }
      return output
    },
    zero_stock() {
      if (this.option_availability.totals === null) {
        return null
      }
      for (let option of Object.values(this.option_availability.totals)) {
        for (let attribute of Object.values(option)) {
          if (attribute > 0) {
            return false
          }
        }
      }
      return true
    },
    is_pre_order(){
      return this.pre_order_date && new Date(this.pre_order_date) > new Date()
    },
    button_text() {
      if (!this.$store.state.product_availability) {
        return ''
      }
      if (this.$store.state.product_availability.shippable) {
        if (this.is_pre_order){
          return product_ctas.pre_order
        }
        return product_ctas.add_to_cart
      }
      if (this.zero_stock) {
        return product_ctas.out_of_stock
      }
      return product_ctas.pickup_only
    },
    cta_text() {
      if (this.zero_stock) {
        return {color: null, value: ''}
      }
      if (!this.selection_made) {
        return {color: 'red', value: product_ctas.no_selection_made}
      }
      if (this.upc === null) {
        return {color: 'red', value: product_ctas.invalid_selection}
      }
      if (this.can_ship_selection) {
        if (this.is_pre_order) {
          return {color: 'blue', value: `${product_ctas.ships_on} ${format_date(new Date(this.pre_order_date), this.$store.state.lang)}`}
        }
        return {color: 'green', value: product_ctas.ship_available}
      }
      if (this.can_pickup_selection) {
        return {color: 'green', value: product_ctas.available_in_store_only}
      }
      return {color: 'red', value: product_ctas.out_of_stock}
    },
    selection_made() {
      for (let x of this.selected_attributes) {
        if (x === null) {
          return false
        }
      }
      return this.selected_attributes.length > 0
    },
    can_ship_selection() {
      if (this.$store.state.product_availability) {
        const a = this.$store.state.product_availability
        if (a.shippable && this.upc in a.variants) {
          for (let store_number of Object.keys(a.variants[this.upc])) {
            if (a.stores[store_number].fulfillment && (a.variants[this.upc][store_number] || 0) > 0) {
              return true
            }
          }
        }
      }
      return false
    },
    can_pickup_selection() {
      if (this.$store.state.product_availability) {
        const a = this.$store.state.product_availability
        if (this.upc in a.variants) {
          for (let store_number of Object.keys(a.variants[this.upc])) {
            if ((a.variants[this.upc][store_number] || 0) > 0) {
              return true
            }
          }
        }
      }
      return false
    }
  },
  methods: {
    draft_review(name, email) {
      this.drafting_review = true
      this.review.customer_name = name
      this.review.customer_email = email
    },
    report_review(review_id) {
      this.reported_reviews[review_id] = false
      axios.put(`/apps/api/reviews?review_id=${review_id}`).then(
          resp => {
            this.reported_reviews[review_id] = true
          },
          err => {
            delete this.reported_reviews[review_id]
          }
      )
    },
    submit_review(e) {
      e.preventDefault()
      this.review.errors = []
      if (!this.review.customer_name.trim()) {
        this.review.errors.push(this.$store.state.lang === 'en' ? 'Name cannot be left blank' : 'Nom ne peut être laissé en blanc')
      }
      if (!this.review.customer_email.trim() || !/^(.*?@.*?\..{1,10})$/.test(this.review.customer_email.trim())) {
        this.review.errors.push(this.$store.state.lang === 'en' ? 'Must provide a valid email' : 'Vous devez fournir une adresse électronique valide')
      }
      if (!this.review.review_title.trim()) {
        this.review.errors.push(this.$store.state.lang === 'en' ? 'Review title cannot be left blank' : "Le titre de l'évaluation ne peut pas être laissé en blanc")
      }
      if (!this.review.review_body.trim()) {
        this.review.errors.push(this.$store.state.lang === 'en' ? 'Review cannot be empty' : 'Évaluation ne peut pas être vide')
      }
      if (this.review.errors.length === 0) {
        this.review.status = 'submitting';
        axios.post('/apps/api/reviews', this.review).then(
            resp => {
              this.review.status = "submitted"
            },
            err => {
              if (err.response.data.error === 'already reviewed this item') {
                this.review.errors.push(this.$store.state.lang === 'en' ? 'You have already reviewed this product' : "Vous avez déjà soumis un avis sur un produit")
              }
              this.review.status = null;
            })
      }

    },
    arrays_equal(a, b) {
      for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
          return false
        }
      }
      return true
    },
    updateOptions: function (option_index, value) {
      // triggered when a variant selection is altered
      this.last_selections = this.last_selections.filter(e => {
        return !e.startsWith(option_index.toString())
      })
      this.last_selections = [`${option_index}-${value}`].concat(this.last_selections).slice(0, this.selected_attributes.length - 1)

      this.selected_attributes[option_index] = value
      this.variant_id = null
      this.upc = null

      let image_id = null
      let possible_images = []
      for (let variant of this.variants) {
        if (this.arrays_equal(variant.options, this.selected_attributes)) {
          this.variant_id = variant.id
          this.upc = parseInt(variant.sku)
          image_id = parseInt(product_data.variants[variant.id].image_id)
          break
        } else if (variant.options[option_index] === value) {
          let potential_img_id = parseInt(product_data.variants[variant.id].image_id)
          if (potential_img_id && !possible_images.includes(potential_img_id)) {
            possible_images.push(potential_img_id)
          }
        }
      }

      // triggers a variant change - updates the displayed pricing, image (if applicable), and UPC/spec data
      if (this.variant_id) {
        let variant = product_data.variants[this.variant_id];
        if (variant) {
          this.product.price = this.$store.getters.currency(variant.price);
          this.product.compare_at_price = variant.compare_at_price
              ? this.$store.getters.currency(variant.compare_at_price)
              : null;
          this.product.savings = variant.compare_at_price
              ? this.$store.getters.currency(variant.compare_at_price - variant.price)
              : null;

          // var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + this.variant_id;
          // window.history.replaceState({path: newurl}, '', newurl);
        }
        this.analytics_update(this.variant_id);
      } else {
        // if there is only 1 potential image (e.g. user clicked on a color without first selecting sizes)
        // we flip to it anyways
        if (possible_images.length === 1) {
          image_id = possible_images[0]
        }
      }
      if (image_id !== null) {
        for (let i = 0; i < product_data.images.length; i++) {
          if (parseInt(product_data.images[i]) === image_id) {
            this.glide.go('=' + i)
            break
          }
        }
      }
    },
    openStoresUSA() {
      this.$store.dispatch("getLocation").then(
          resp => {
            this.$store.state.global_components.overlay.openModal({
              modal: 'pickup',
              stores: this.$store.getters.get_pickup_stores(null),
              item: this.item
            });
          },
          () => {
          }
      )
    },
    addToCart(e, pickUpStore) {
      if (e) {
        e.preventDefault();
      }

      this.custom_validation_errors = {}
      let has_custom_props = false
      let custom_props = {}
      const f = document.getElementsByClassName('_custom-attribute')
      for (let inp of f) {
        has_custom_props = true
        let valid = inp.checkValidity()
        if (!valid) {
          this.custom_validation_errors[inp.name] = 'blank'
        }
        if (inp.type === 'radio') {
          if (inp.checked) {
            custom_props[inp.name] = inp.value
          }
        } else {
          custom_props[inp.name] = inp.value
        }
      }
      if (has_custom_props && this.custom_prop_validator !== null && this.custom_prop_validator !== undefined && this.custom_prop_validator !== '') {
        for (let err_field of (this.custom_prop_validator(custom_props) || [])) {
          if (!(err_field in this.custom_validation_errors)) {
            this.custom_validation_errors[err_field] = "blank"
          }
        }
      }
      if (Object.keys(this.custom_validation_errors).length > 0) {
        for (let key of Object.keys(this.custom_validation_errors)){
          if (key in custom_props && custom_props[key]){
            // for each error, if a value is set, change the rejection reason from 'blank' to 'invalid'
            this.custom_validation_errors[key] = 'invalid'
          }
        }
        return
      }

      this.add_to_cart_error = false

      let data = {
        id: this.variant_id,
        quantity: 1,
      };
      if (custom_props) {
        if (pickUpStore) {
          custom_props._store_for_pickup = pickUpStore
        }
        data.properties = custom_props
      } else if (pickUpStore) {
        data.properties = {
          _store_for_pickup: pickUpStore
        }
      }

      const fire_add_to_cart_datalayer = () => {
        let data_layer_item = this.getDataLayerItem(this.variant_id)
        data_layer_item.location_id = pickUpStore || 0
        data_layer_item.quantity = 1
        dataLayer.push({ecommerce: null});
        dataLayer.push({
          'event': 'add_to_cart',
          'ecommerce': {
            'items': [data_layer_item]
          }
        });
      }

      let incremented_existing = false;
      this.$store.dispatch("getCart").then(cart => {
        if (this.$store.state.cart) {
          // see if we can increment an existing cart line
          for (let item of this.$store.state.cart.items) {
            if (item.variant_id === parseInt(this.variant_id)) {
              let ex_props = Object.fromEntries(
                  Object.entries(
                      item.properties || {}
                  ).filter(e => e[0] !== '_cart_token')
              )
              if (objectsAreEqual(ex_props, data.properties || {})) {
                incremented_existing = true
                axios.post(`${this.$store.getters.locale_uri_prefix}/cart/change.js`, {
                  id: item.key,
                  quantity: item.quantity + 1,
                }).then(
                    response => {
                      if (response.status === 200) {
                        this.$store.commit({type: 'setCart', value: response.data})
                        fire_add_to_cart_datalayer()
                        this.$store.state.global_components.overlay.openModal({modal: "atc"});
                      } else {
                        this.add_to_cart_error = true;
                      }
                    },
                    err => {
                      console.error('Error adding to cart', err)
                      throw 'Error adding to cart';
                    }
                )
              }
            }
          }
        }

        if (!incremented_existing) {
          // if we couldn't increment an existing item, then add it outright
          axios.post(`${this.$store.getters.locale_uri_prefix}/cart/add.js`, data).then(
              response => {
                if (response.status === 200) {
                  this.$store.commit('addCartItem', response.data)
                  fire_add_to_cart_datalayer()
                  this.$store.state.global_components.overlay.openModal({modal: "atc"});
                } else {
                  this.add_to_cart_error = true;
                }
              },
              err => {
                console.error('Error adding to cart', err)
                throw 'Error adding to cart';
              }
          )
        }
      })

    },
    initGlide: function () {
      //Initialize JS plugin for images
      this.glide = new Glide(".js-product-images")
      this.glide.on("move", () => {
        document.activeElement.blur();
      });
      this.glide.mount();
    },
    openModal(modal, src, alt) {
      dataLayer.push({'event': 'changeProductFocus', 'focusArea': modal})
      this.$store.state.global_components.overlay.openModal({modal: modal, src: src, alt: alt});
    },
    expandOverview: function () {
      dataLayer.push({'event': 'changeProductFocus', 'focusArea': 'description'})
      this.description_expand = true;
    },
    activateTab(tab, ignore_evt = false) {
      if (!ignore_evt) {
        dataLayer.push({'event': 'changeProductFocus', 'focusArea': tab})
      }
      this.active_tab = tab
    },
    openReview() {
      document.getElementsByClassName("js-product-details")[0]
      .scrollIntoView({behavior: "smooth", block: "start"});
      this.activateTab("reviews");
    },
    getDataLayerItem(selected_id) {
      let dl_value = JSON.parse(product_data.datalayer)
      let selected_var = product_data.variants[selected_id]
      dl_value.price = parseInt(selected_var.price) / 100
      if (selected_var.compare_at_price) {
        dl_value.discount = (parseInt(selected_var.price) - parseInt(selected_var.compare_at_price)) / 100
      }
      dl_value.item_variant = selected_var.title
      return dl_value
    },
    analytics_update: function (selectedId) {
      dataLayer.push({ecommerce: null});
      dataLayer.push({
        'event': 'view_item',
        'ecommerce': {
          'items': [this.getDataLayerItem(selectedId)]
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch("getLocation").then(
        resp => {
          this.$store.dispatch("getProductAvailability", parseInt(this.pid))
        },
        () => {
        })

    // initialize image carousel
    this.initGlide();

    // check if a variant ID was passed to the query string
    const params = new URLSearchParams(window.location.search);
    let selected_variant = null;
    let selected_options = null;
    if (params.get("variant")) {
      selected_variant = parseInt(params.get("variant")) || null
    }

    // build the variant array
    if (document.querySelector("select[name='id']")) {
      document.querySelectorAll("select[name='id'] option").forEach((variant) => {
        if (variant.dataset && variant.dataset.sku) {
          this.variants.push({
            id: variant.value,
            sku: variant.dataset.sku,
            options: decodeURI(variant.dataset.options).split(/\|/g).map(e => {
              return handleize(e)
            }),
          });
          if (selected_variant && parseInt(variant.value) === selected_variant) {
            selected_options = this.variants[this.variants.length - 1].options
          }
        }
      });
      this.selected_attributes = this.variants[0].options.map(e => null)
    }

    // activate the selection from the query string if present
    if (selected_options !== null) {
      for (let idx = 0; idx < selected_options.length; idx++) {
        let ele = document.getElementById(`${idx}-${selected_options[idx]}`)
        if (ele) { // click the variant selector if it exists to show highlights
          ele.click()
        }
        this.updateOptions(idx, selected_options[idx])
      }
    }
    // otherwise activate the first selection if this is a one-size item
    else if (this.variants.length === 1) {
      for (let idx = 0; idx < this.variants[0].options.length; idx++) {
        this.updateOptions(idx, this.variants[0].options[idx])
      }
    }

    // activate the first tab
    if (document.querySelector(".js-product-details-tab")) {
      this.activateTab(document.querySelector(".js-product-details-tab").dataset.tab, true)
    }

    // initialize price, etc. with the first variant
    const variant = Object.values(product_data.variants)[0]
    this.product.price = this.$store.getters.currency(variant.price);
    this.product.compare_at_price = variant.compare_at_price
        ? this.$store.getters.currency(variant.compare_at_price) : null;
    this.product.savings = variant.compare_at_price
        ? this.$store.getters.currency(variant.compare_at_price - variant.price) : null;
    this.initGlide();
  },
}